export default __webpack_public_path__ + "static/media/Nunito-Regular.328e9506.woff";